import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-coupon-icon',
  templateUrl: './coupon-icon.component.html',
  styleUrls: ['./coupon-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CouponIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
